module.exports = __webpack_public_path__ + "media/Finale2.d3f86d93.mp3";